<template>
  <div class='xy-content-module'>
    <van-nav-bar fixed>
      <div slot="left" @click="close" class="icon-title-line">
        <van-icon name="arrow-left" color="#333" class="icon-title-size" />
      </div>
      <div slot="title" class="all-title">发起邀请</div>
    </van-nav-bar>
    <div class='xy-content-body'>
        <div class="visit-apply-from"> 
          <van-cell-group>
            <van-field 
              :rows="1"
              v-model="vName" 
              type="textarea" 
              show-word-limit
              maxlength="50" 
              label="邀请主题" 
              placeholder="请输入邀请主题" 
              @input="inputEmoji()"
              style="color: rgba(0,0,0,0.65);"
              />
            <div style="width:100%;height:8px;background: #f9f9f9;"></div>
            <van-field 
              :rows="4"
              class="visit-explain" 
              v-model="vMessage"
              type="textarea"
              maxlength="200"
              label="邀请内容" 
              placeholder="请输入邀请内容"
              show-word-limit
              @input="inputEmoji()" 
              style="color: rgba(0,0,0,0.65);"
              />
            <div style="width:100%;height:8px;background: #f9f9f9;"></div>
            <van-field v-model="vIntervieweeTime" @click="isShowPreDate=true" label="到访时间" is-link disabled style="color: rgba(0,0,0,0.65);"/>
            <van-field v-model="vAddress" @input="inputEmoji()" label="添加地址" placeholder="请输入邀请地址" class="add-ress" maxlength="100" show-word-limit style="color: rgba(0,0,0,0.65);"/>
        </van-cell-group>
        <div class="box-body">
            <div class="box-body-title">
                <span style="color: rgba(0,0,0,0.65);font-weight: 600;">邀请嘉宾 （{{vInformation.length}}人）</span>
                <div>
                  <img class="hoverImage" @click="edit" src="@/assets/schoolAffairs/add.png" alt="图片"/>
                  <img class="hoverImage" @click="deleteAll" style="margin-left:24px" src="@/assets/schoolAffairs/delete.png" alt="图片"/>
                </div>
                <!-- <img class="hoverImage" @click="edit" style="width:38px;height:38px" src="@/assets/schoolAffairs/edit.png" alt="图片"/> -->
            </div>
            <div v-for="(item, index) in vInformation" :key="index" class="teachers-show" >
                <div class="teachers-show-item" @click="showPopup(item,index)" >
                  <div class="iconName">
                      <span class="left-span" :style="{background:'#1677FF',color:'#fff'}">{{xy.showName(item.name)}}</span>
                  </div>
                  <div class="content-text" >
                      <span style="color: rgba(0, 0, 0, 0.85);">{{item.name}}</span><br/>
                      <span  style="color: rgba(0, 0, 0, 0.65);">手机号：{{item.phone}}</span>
                  </div>
                  <div class="edit-text">
                     <img style="width:16px;height:auto" src="@/assets/schoolAffairs/dian.png" alt="图片"/>
                  </div>
                </div>
            </div>
            <div v-show="vInformation.length===0" style="text-align:center;margin-top:40px;color:#ccc">
              暂无嘉宾名单，请先添加邀请嘉宾。
            </div>
        </div>
      <!-- 日期 -->
      <van-popup v-model="isShowPreDate" position="bottom" :style="{ height: '45%' }">
        <van-datetime-picker
          :min-date="minDate"
          @confirm="preDateConfirm"
          @cancel="preDateCancle"
          type="datetime"
        ></van-datetime-picker>
      </van-popup>
      <!--input弹窗--->
      <van-dialog v-model="isShowInput" position="bottom" confirm-button-text=" ">
        <h3 style="height: 70px;text-align: center;line-height: 70px;font-size: 20px;">添加邀请嘉宾</h3>
        <van-form @submit="onSubmit1" style="padding: 10px;">
          <p style="margin-bottom: 10px;">邀请人姓名</p>
          <van-field
            style="background: #F5F5F5;padding: 10px;"
            v-model="username"
            name="邀请人姓名"
            placeholder="邀请人姓名"
            @input="inputEmoji()"
          />
          <p style="margin: 16px 0 10px 0;">邀请人手机号</p>
          <van-field
            style="background: #F5F5F5;padding: 10px;"
            v-model="userphone"
            name="邀请人手机号"
            placeholder="邀请人手机号"
            type="number"
          />
          <div style="margin: 16px;display: flex;">
            <van-button round block type="default" native-type="submit" style="margin-right:5px;border: 1px solid #ccc;" @click="cancel">
              取消
            </van-button>
            <van-button round block type="info" native-type="submit" style="margin-left:5px" @click="confirmation">
              确认
            </van-button>
          </div>
        </van-form>
      </van-dialog>
      <!--发送弹窗--->
      <van-dialog v-model="isShowtip" position="bottom" confirm-button-text=" ">
        <h3 style="height: 100px;text-align: center;line-height: 140px;font-size: 20px;">您确定发送邀请信息吗？</h3>
        <van-form @submit="onSubmit1" style="padding: 10px;">
          <div style="margin: 16px;display: flex;">
            <van-button round block type="default" native-type="submit" style="margin-right:5px;border: 1px solid #ccc;" @click="cancelTip">
              取消
            </van-button>
            <van-button round block type="info" native-type="submit" style="margin-left:5px" @click="confirmationTip">
              确认
            </van-button>
          </div>
        </van-form>
      </van-dialog>
      <!---弹出编辑---->
      <van-popup v-model="isShowEdit" class="edit-div" position="bottom"  >
        <div class="text-align:center" @click="editRevise()">编辑</div>
        <div class="text-align:center" @click="ondelete()">删除</div>
        <p style="width:100%;height:8px;background:#F5F5F5"></p>
        <div @click="cancelEdit">取消</div>
      </van-popup>
      <SingleBottomBtn @clickBtn="onSubmit" style="z-index:9" >发送</SingleBottomBtn>
    </div>
    </div>
  </div>
</template>
<script>
  import SingleBottomBtn from "../../../../attendance/components/SingleBottomBtn";
  export default {
    name: '',
    data () {
      return {
          vName:'',
          vIntervieweeTime:'',
          vMessage:'',
          vAddress:'',
          isShowPreDate: false,
          minDate: new Date(),
          vInformation:[],
          isShowInput:false,
          isShowtip:false,
          isShowEdit:false,
          userphone:'',
          username:'',
          editIndex: -1,
          nowIndex:null,
          nowItem:null,
          rowRoleType:null
      }
    },
    components: {
      SingleBottomBtn
    },
    created () {},
    mounted () {
        this.rowRoleType = this.$store.state.common.userInfo
        console.log(this.rowRoleType)
    },
    methods :{
        inputEmoji(){
          var regStr = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\uA9|\uAE]\u3030|\uA9|\uAE|\u3030/ig; 
          if(regStr.test(this.vName)){        
              this.vName = this.vName.replace(regStr,"");   
          }else if(regStr.test(this.vMessage)){
              this.vMessage = this.vMessage.replace(regStr,"");   
          }else if(regStr.test(this.vAddress)){
              this.vAddress = this.vAddress.replace(regStr,"");   
          }else if(regStr.test(this.username)){
              this.username = this.username.replace(regStr,"");   
          }
        },
        //到访日期
        preDateConfirm(val) {
        this.vIntervieweeTime = this.xy.moment(val).format("YYYY-MM-DD HH:mm");
        this.isShowPreDate = false;
        },
        preDateCancle() {
        this.isShowPreDate = false;
        },
        close(){
          this.$router.go(-1);
        },
        onSubmit1(values) {
          console.log('submit', values);
        },
        //-----添加邀请嘉宾
        //点击三个点编辑
        showPopup(item,index){
          this.isShowEdit = true
          this.nowIndex = index
          this.nowItem = item
        },
        cancelEdit(){
          this.isShowEdit = false
        },
        edit(){
          this.editIndex = -1
          this.isShowInput = true
          this.username = ''
          this.userphone = ''
        },
        //修改
        editRevise(){
          this.isShowEdit = false
          this.isShowInput = true
          this.username = this.nowItem.name
          this.userphone = this.nowItem.phone
          this.editIndex = this.nowIndex
        },
        //删除所有
        deleteAll(){
          this.xy.confirm('删除', `您确认要删除所有邀请人吗？`, () => {
            this.vInformation.splice(0,this.vInformation.length)
          })
        },
        //删除
        ondelete(){
          this.isShowEdit = false
          this.xy.confirm('删除', `您确认要删除当前邀请人吗？`, () => {
            this.vInformation.splice(this.nowIndex,1)
            console.log(this.vInformation)
          })
        },
        //取消
        cancel(){
          this.isShowInput = false
        },
        //确认
        confirmation(){
          if(!this.username.trim()){
            this.xy.msgError('姓名不能为空。')
            return
          }
          if (!(/^1[3456789]\d{9}$/.test(this.userphone))) {
            this.xy.msgError('手机号不正确，请填写正确手机号。')
            return
          }else{
            if(this.editIndex === -1){
            //添加
            var exist = false
            for (var j = 0; j < this.vInformation.length; j++) {
              if (this.userphone.toString() === this.vInformation[j].phone.toString()) {
                exist = true
                this.vInformation[j].name = this.username
              }
            }
            if (!exist) {
              let namePhone = {
                name:this.username,
                phone:this.userphone
              }
              this.vInformation.push(JSON.parse(JSON.stringify(namePhone)))
            }
            this.isShowInput = false
            }else{
              //修改
              let iphoneArr = []
              for (var i = 0; i < this.vInformation.length; i++) {
                iphoneArr.push(Number(this.vInformation[i].phone))
              }
              console.log(iphoneArr)
              if (iphoneArr.includes(Number(this.userphone)) && Number(this.userphone) !== iphoneArr[this.editIndex]) {
                this.xy.msgError('手机号已存在，请填写正确手机号。')
                return false
              } else {
                this.isShowInput = false
              }
              this.vInformation[this.editIndex].name = this.username
              this.vInformation[this.editIndex].phone = this.userphone
            }
          }
          // this.isShowInput = false
        },
        cancelTip(){
          this.isShowtip = false
        },
        //-----发送
        onSubmit(){
          if(!this.vName.trim()){
            this.xy.msgError('邀请主题不能为空。')
            return
          }
          if(!this.vMessage.trim()){
            this.xy.msgError('邀请内容不能为空。')
            return
          }
          if(!this.vIntervieweeTime.trim()){
            this.xy.msgError('到访时间不能为空。')
            return
          }
          if(!this.vAddress.trim()){
            this.xy.msgError('到访地址不能为空。')
            return
          }
          if(this.vInformation.length===0){
            this.xy.msgError('邀请人员信息不能为空。')
            return
          }
            // 判断时间是否有效
            let timeHours = Number(this.vIntervieweeTime.slice(11, 13))
            let timeMinutes = Number(this.vIntervieweeTime.slice(14, 16))
            let timeHoursMinutes = [timeHours, timeMinutes]
            let nowHours = Number(new Date().getHours())
            let nowMinutes = Number(new Date().getMinutes())
            let nowHoursMinutes = [nowHours, nowMinutes]
            console.log(timeHoursMinutes)
            const resDate = this.xy.moment(this.vIntervieweeTime).format('YYYY-MM-DD')
            const resDate1 = this.xy.moment().format('YYYY-MM-DD')
            console.log(nowHoursMinutes)
            if (resDate === resDate1 && nowHoursMinutes[0] >= timeHoursMinutes[0]) {
              if (nowHoursMinutes[1] >= timeHoursMinutes[1]) {
                this.xy.msgError('到访时间需要大于当前时间。')
                return false
              }
            }
          this.isShowtip = true
        },
        //确认 您确认发送邀请信息吗？
        confirmationTip(){
          this.isShowtip = false
          this.sendOut()
        },
        async sendOut(){
          const vforom = this.vInformation.map(item => {
            return {
              'InvatationFullName': item.name,
              'InvatationPhoneNumber': item.phone.toString()
            }
          })
          const webSiteTitle = localStorage.getItem("webSiteTitle")
          const LinkUrl = this.xyWebUrl + '/homeSchool/InvitationLink'
          let params = {
            InvatationTitle: this.vName, // 邀请主题
            InvatationContent: this.vMessage, // 邀请内容
            InvatationArriveTime: this.vIntervieweeTime, // 邀请到访时间
            InvatationArriveAddress: this.vAddress, // 邀请到访地址
            InvatationUsers: vforom, // 邀请人员信息（手机号和姓名数组
            InvatationSchoolName: webSiteTitle, // 学校名称
            LinkUrl: LinkUrl,
            ApiUrl: this.xyMApi  //apiUrl
          }
          let res = await this.xyapi.post(
            this.xyMApi+'/vst' + "/invatation/InsertInvatationInfo",params
           // 'http://devpczx.xiaoyangedu.net:9092' + '/vst/invatation/InsertInvatationInfo', params
          )
          if (res !== undefined && res.success) {
            params.InvatationUser = this.rowRoleType.FullName
            console.log(params)
            // this.xy.msgSuc('邀请成功！')
            localStorage.setItem("launchInvitation", JSON.stringify(params));
            this.$router.push({
              path: "/home/VisitTips"
            });
          }
        }
    }
  }
</script>
<style lang='less' scoped>
          .box-body{
            width:100%;
            height: 880px;
            overflow: auto;
            margin-top: 16px;
            background: #ffffff;
            padding-bottom: 110px;
            .box-body-title{
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding:16px 30px;
                border-bottom: 1px solid #eeeeee;
                div{
                  .hoverImage{
                    width:32px;height:32px
                  }
                }
            }
            .teachers-show{
              width:100%;
              height:110px;
              padding:0px 0px 0px 30px;
              margin-top: 30px;
              // margin-bottom: 33px;
              .teachers-show-item{
                width:100%;
                height:100%;
                border-bottom: 1px dashed #E5E5E5;
                .iconName{
                  float:left;
                  .left-span{
                    display: inline-block;
                    width: 78px;
                    height: 78px;
                    border-radius:50%;
                    line-height:74px;
                    text-align:center;
                    color:#fff;
                  }
                }
                .content-text{
                  float:left;
                  margin: 0 15px;
                  flex: 6;
                  margin-bottom: 4px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
                .edit-text{
                  float: right;
                  margin-right: 40px;
                  padding-top: 12px;
                }
              }
            }
          }
.edit-div{
  color: #333;
  div{
    height: 100px;
    text-align: center;
    line-height: 100px;
    font-size: 30px;
    border-bottom: 1px solid #E5E5E5;
  }
}
.icon-title-line{
  display: flex;
  align-items: center;
}
.icon-title-size{
  font-size: 38px;
}
 /deep/ .van-dialog__footer{
  display: none;
}
.add-ress /deep/ .van-field__body{
  position: absolute;
  width: 77%;
}
.add-ress /deep/ .van-field__word-limit{
  display: inline-block;
}
</style>
